import { useAppActions } from 'reducers/slices/buyerSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { setRealEstateAgentReferral } = useAppActions();
  const { realEstateAgentReferralSettingsStatus } = useSelector(state => state.buyerSlice);

  return {
    isReferralSettingsStatusLoading: useFetchStatus(realEstateAgentReferralSettingsStatus).isPending,
    isReferralSettingsStatusIdle: useFetchStatus(realEstateAgentReferralSettingsStatus).isIdle,
    setRealEstateAgentReferral,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useBuyer.js